export default __webpack_public_path__ + "static/media/Wechart.67bd7922.jpg";